import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  IconButton,
  Menu,
  MenuItem,
} from '@mui/material';
import {
  Home as HomeIcon,
  LocalFireDepartment as FlameIcon,
  ThermostatAuto as TempIcon,
  MoreVert as MoreIcon,
} from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleNavigation = (path) => {
    navigate(path);
    setCurrentPath(path);
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
    handleMenuClose();
  };

  const getNavigationValue = () => {
    switch (currentPath) {
      case '/':
        return 0;
      case '/heating':
        return 1;
      case '/temperatures':
        return 2;
      default:
        return 0;
    }
  };

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      height: '100vh',
      overflow: 'hidden',
    }}>
      {/* Top App Bar */}
      <AppBar position="static" elevation={1}>
        <Toolbar>
          <Box component="img" src="/icons/favicon.svg" alt="logo" sx={{ width: 42, height: 42, mr: 1 }} />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Heat Monitor
          </Typography>
          <Typography variant="body2" sx={{ mr: 1 }}>
            {user?.name}
          </Typography>
          <IconButton
            color="inherit"
            onClick={handleMenuOpen}
            size="small"
          >
            <MoreIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
          >
            <MenuItem onClick={() => { handleNavigation('/profile'); handleMenuClose(); }}>
              Profile
            </MenuItem>
            <MenuItem onClick={handleLogout}>
              Logout
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1, 
          overflow: 'auto',
          pb: 7, // Space for bottom navigation
          backgroundColor: 'background.default',
        }}
      >
        {children}
      </Box>

      {/* Bottom Navigation */}
      <Paper 
        sx={{ 
          position: 'fixed', 
          bottom: 0, 
          left: 0, 
          right: 0,
          zIndex: 1000,
        }} 
        elevation={3}
      >
        <BottomNavigation
          value={getNavigationValue()}
          onChange={(event, newValue) => {
            const paths = ['/', '/heating', '/temperatures'];
            handleNavigation(paths[newValue]);
          }}
          showLabels
        >
          <BottomNavigationAction 
            label="Homes" 
            icon={<HomeIcon />} 
          />
          <BottomNavigationAction 
            label="Heating" 
            icon={<FlameIcon />} 
          />
          <BottomNavigationAction 
            label="Temperatures" 
            icon={<TempIcon />}
          />
        </BottomNavigation>
      </Paper>
    </Box>
  );
};

export default Layout;